import __vue_component__ from '../HseIcon/HseIcon.vue.js';

//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=289%3A0
 * @storybook /?path=/story/tag-tag--playground
 * @react /src-components-tag
 * @reactStorybook /?path=/story/tag-tag--playground
 */
var script = {
  name: 'HseTag',
  components: {
    HseIcon: __vue_component__
  },
  props: {
    /**
     * Произвольный компонент
     */
    component: {
      type: [String, Object],
      default: 'div'
    },
    /**
     * Иконка слева
     */
    leftIcon: {
      type: [String, Object],
      default: null
    },
    /**
     * Иконка справа
     */
    rightIcon: {
      type: [String, Object],
      default: null
    },
    /**
     * Размер компонента
     * @values small, medium
     */
    size: {
      type: String,
      validator: v => ['small', 'medium'].includes(v),
      default: 'small'
    },
    /**
     * Отключенное состояние
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Выбранное состояние
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * Сфокусированное состояние
     */
    focused: {
      type: Boolean,
      default: false
    },
    /**
     * Кликабельное состояние
     */
    clickable: {
      type: Boolean,
      default: false
    },
    /**
     * Состояние hover
     */
    hovered: {
      type: Boolean,
      default: false
    },
    /**
     * Дополнительные классы элементов:
     * - icon – элемент иконки
     * - iconLeft – элемент левой иконки
     * - iconRight – элемент правой иконки
     * - children – класс default слота
     * @type {{
     *  icon?: string;
        iconLeft?: string;
        iconRight?: string;
        children?: string;
     * }}
     */
    classes: {
      type: Object,
      default: () => ({
        icon: '',
        iconLeft: '',
        iconRight: '',
        children: ''
      })
    }
  },
  computed: {
    leftIconClassName() {
      const { classes } = this;
      return {
        'hse-Tag__icon': true,
        'hse-Tag__icon_left': true,
        [classes.icon]: classes.icon,
        [classes.iconLeft]: classes.iconLeft,
      }
    },
    rightIconClassName() {
      const { classes } = this;
      return {
        'hse-Tag__icon': true,
        'hse-Tag__icon_right': true,
        [classes.icon]: classes.icon,
        [classes.iconRight]: classes.iconRight,
      }
    }
  }
};

export default script;
